<template>
  <section class="d-grid gap-4">
    <header>
      <h2 class="h4 mb-1">Mantenimiento del sistema</h2>
      <p class="text-muted mb-0">
        Este módulo centraliza configuraciones operativas y fiscales del POS.
      </p>
    </header>

    <div class="row g-3">
      <div class="col-md-4">
        <div class="card shadow-sm h-100">
          <div class="card-body">
            <h3 class="h6">Operativo</h3>
            <p class="text-muted small mb-3">Configuración local de impresión, inventario y parámetros operativos.</p>
            <router-link class="btn btn-dark btn-sm" :to="{ name: 'MaintenanceOperational' }">Abrir</router-link>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card shadow-sm h-100">
          <div class="card-body">
            <h3 class="h6">Balanzas</h3>
            <p class="text-muted small mb-3">Formatos de códigos pesables y reglas de parsing para lectura desde balanza.</p>
            <router-link class="btn btn-dark btn-sm" :to="{ name: 'MaintenanceScales' }">Abrir</router-link>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card shadow-sm h-100">
          <div class="card-body">
            <h3 class="h6">Fiscal</h3>
            <p class="text-muted small mb-3">Establecimientos, puntos de expedición, timbrados y series activas.</p>
            <div class="d-flex gap-2 flex-wrap">
              <router-link class="btn btn-dark btn-sm" :to="{ name: 'MaintenanceFiscalDashboard' }">Abrir</router-link>
              <router-link class="btn btn-outline-dark btn-sm" :to="{ name: 'MaintenanceFiscalSeries' }">Ver series</router-link>
            </div>
          </div>
        </div>
      </div>
      <div v-if="canViewUsers || canManageCashboxes" class="col-md-4">
        <div class="card shadow-sm h-100">
          <div class="card-body">
            <h3 class="h6">Usuarios y Cajas</h3>
            <p class="text-muted small mb-3">Asignación de sucursales por usuario y configuración de cajas por establecimiento.</p>
            <div class="d-flex gap-2 flex-wrap">
              <router-link v-if="canViewUsers" class="btn btn-dark btn-sm" :to="{ name: 'UserManagement' }">Usuarios</router-link>
              <router-link v-if="canManageCashboxes" class="btn btn-outline-dark btn-sm" :to="{ name: 'MaintenanceCashboxes' }">Cajas</router-link>
            </div>
          </div>
        </div>
      </div>
      <!-- Ecommerce e Imágenes se mudaron a su propia sección /ecommerce
           (RF-2). Se deja este acceso como puente para quien todavía los
           busca acá, en vez de que parezca que desaparecieron. -->
      <div v-if="canManageEcommerce || canManageImages" class="col-md-4">
        <div class="card shadow-sm h-100">
          <div class="card-body">
            <h3 class="h6">Ecommerce</h3>
            <p class="text-muted small mb-3">
              Configuración del storefront, mensajes al cliente e imágenes de catálogo.
              Ahora vive en su propia sección.
            </p>
            <router-link class="btn btn-dark btn-sm" :to="{ name: 'EcommerceHome' }">Ir a Ecommerce</router-link>
          </div>
        </div>
      </div>
      <div v-if="canManageJobs" class="col-md-4">
        <div class="card shadow-sm h-100">
          <div class="card-body">
            <h3 class="h6">Jobs programados</h3>
            <p class="text-muted small mb-3">Backfill nocturno de imágenes y resumen diario de ventas/caja por email.</p>
            <router-link class="btn btn-dark btn-sm" :to="{ name: 'MaintenanceJobs' }">Abrir</router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'
import { hasPermission } from '@/services/authSessionService'

const canViewUsers = computed(() => hasPermission('ver_usuarios'))
const canManageCashboxes = computed(() => hasPermission('actualizar_deposito'))
const canManageEcommerce = computed(() => hasPermission('gestionar_ecommerce'))
const canManageImages = computed(() => hasPermission('editar_productos'))
const canManageJobs = computed(() => hasPermission('gestionar_jobs'))
</script>
